import React, { useMemo } from 'react';
import { Block } from "@randajan/jet-react/dom/block";
import { Link } from '@randajan/jet-react/dom/link';
import { screen } from '@randajan/jet-react/base/screen';
import { useBeam } from '@randajan/bifrost/client/react';

import "./Community.scss";
import { globalStatsBeam } from '../../assets/beams/globalStatsBeam';
import { Locale } from '../../assets/Locale';
import { DataView } from '../../elements/DataView/DataView';
import { CharacterCard } from '../../frames/Profile/CharacterCard/CharacterCard';
import { BlimpRating } from '../../elements/Graphs/BlimpRating/BlimpRating';
import { Timer } from '../../elements/Clocks/Timer/Timer';
import { statsTypes } from '../../../arc/game/_consts';
import { getStatField } from '../../../arc/game/showStats';

const renderProfile = (aliasKey, profile)=>(
    <Link to={`/whois/${aliasKey}`}>
        <CharacterCard profile={profile} />
    </Link>
);

const renderRating = value=>(
    <BlimpRating value={value} from={0} to={1} step={1 / 10} />
);

const renderLastPresent = value=>value ? (
    <Timer value={value} clockOpt={{ depth:1 }} targetOpt={{ hour:"hide", minute:"hide" }} />
) : null;

const getStatLabel = (say, id)=>getStatField(id, {}, say).label;

const generateColumns = say=>[
    {
        id:"rank",
        header:getStatLabel(say, "rank"),
        accessAs:(_, profile)=>profile.stats?.rank,
        renderAs:value=>`${statsTypes.int(value)}.`
    },
    {
        id:"aliasKey",
        header:say("profileHeaderMember"),
        renderAs:renderProfile
    },
    {
        id:"rankRate",
        header:say("profileStatsSectionRating"),
        accessAs:(_, profile)=>profile.stats?.rankRate,
        renderAs:renderRating
    },
    {
        id:"rounds",
        header:getStatLabel(say, "rounds"),
        accessAs:(_, profile)=>profile.stats?.rounds,
        renderAs:statsTypes.int
    },
    {
        id:"betaTotal",
        header:getStatLabel(say, "beta"),
        accessAs:(_, profile)=>(profile.stats?.beta || 0) + (profile.stats?.alphaBeta || 0),
        renderAs:statsTypes.int
    },
    {
        id:"lastPresent",
        header:say("profileStatsPresenceLast"),
        accessAs:(_, profile)=>profile.stats?.lastPresent,
        sortAs:value=>new Date(value).getTime(),
        searchAs:value=>value ? say.dateTime(value) : "",
        renderAs:renderLastPresent
    }
];

export const Community = ()=>{
    const { data:gStats } = useBeam(globalStatsBeam);
    const [wideScreen] = screen.use("1280w");
    const forceView = !wideScreen.get() && "grid";

    const say = Locale.use();
    const columns = useMemo(()=>generateColumns(say), [say]);

    return (
        <Block level={0} className="Community" caption={say("CommunityCaption")}>
            <section className="slab wall -dark -border">
                <DataView
                    virtualAbove={0}
                    virtualOffset={-0.1}
                    transition={250}
                    defaultView="table"
                    forceView={forceView}
                    say={say}
                    data={gStats?.users?.list}
                    columns={columns}
                />
            </section>
        </Block>
    )
}
